import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  Table,
  Space,
  Modal,
  Button,
  Form,
  Input,
  Row,
  Col,
  message,
  Descriptions,
  Tabs,
  Select,
  InputNumber,
  DatePicker,
} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { BarChartOutlined, ExperimentOutlined } from '@ant-design/icons';
import { QaqcAnalysisService } from '@gtpl/shared-services/raw-material-procurement';
import { CreateQaqcFibreAnalysisReq, CreateQaqcFibreLabAnalysisReq, QaqcWorkOrderReq, QaqcLotReq } from '@gtpl/shared-services/raw-material-procurement';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ProductService, SkuService } from '@gtpl/shared-services/masters';
import { QualityTypeEnum } from '@gtpl/shared-models/common-models';
import { LotCodeDropDown } from '@gtpl/shared-models/production-management';
const { Option } = Select;


export enum QAQCAnalysisTypeEnum {
  SILK_FIBER_ANALYSIS = 'SILKFIBERANALYSIS',
  SILK_FIBER_LAB_ANALYSIS = 'SILKFIBERLABANALYSIS',
}

type AnalysisType = QAQCAnalysisTypeEnum | null;

const QaqcAnalysisView: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [analysisType, setAnalysisType] = useState<AnalysisType>(null);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [activeTab, setActiveTab] = useState('work-order');
  const [workOrders, setWorkOrders] = useState<any[]>([]);
  const [lots, setLots] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [filterForm] = Form.useForm();
  const { RangePicker } = DatePicker;
        const [page, setPage] = React.useState(1); 

  const qaqcService = new QaqcAnalysisService();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const productService = new ProductService();
  const [productsData, setProductsData] = useState<any[]>([]);
  const [skuCodesData, setSkuCodesData] = useState<any[]>([]);
  const [lotNumDropdownData, setLotNumDropdownData] = useState<any[]>([]);
  const [workOrdersDropdownData, setWorkOrdersDropdownData] = useState<any[]>([]);
  const skucodeservice = new SkuService();
  useEffect(() => {
    fetchData();
  }, [activeTab]);

  useEffect(() => {
    getAllProducts();
    getAllSkuCodes();
    getLotsDropdownForQAQC()
    getWorkOrdersDropdownForQAQC();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      if (activeTab === 'work-order') {
        const req = new QaqcWorkOrderReq();
        if (filterForm.getFieldValue('variant')) {
          req.variant = filterForm.getFieldValue('variant')
        }
        if (filterForm.getFieldValue('quality')) {
          req.quality = filterForm.getFieldValue('quality')
        }
        if (filterForm.getFieldValue('WorkOrder')) {
          req.workOrderNo = filterForm.getFieldValue('WorkOrder')
        }
        if (filterForm.getFieldValue('testDate') && filterForm.getFieldValue('testDate')[0]) {
          req.fromDate = (filterForm.getFieldValue('testDate')[0]).format('YYYY-MM-DD');
          req.toDate = (filterForm.getFieldValue('testDate')[1]).format('YYYY-MM-DD');
        }
        const res = await qaqcService.getWorkOrdersForQAQC(req);
        if (res.status) {
          setWorkOrders(res.data);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
          setWorkOrders([]);
        }
      } else {
        const req = new QaqcLotReq();
        if (filterForm.getFieldValue('variant')) {
          req.variant = filterForm.getFieldValue('variant')
        }
        if (filterForm.getFieldValue('quality')) {
          req.quality = filterForm.getFieldValue('quality')
        }
        if (filterForm.getFieldValue('lotNo')) {
          req.lotNumber = filterForm.getFieldValue('lotNo')
        }
        if (filterForm.getFieldValue('testDate') && filterForm.getFieldValue('testDate')[0]) {
          req.fromDate = (filterForm.getFieldValue('testDate')[0]).format('YYYY-MM-DD');
          req.toDate = (filterForm.getFieldValue('testDate')[1]).format('YYYY-MM-DD');
        }
        const res = await qaqcService.getLotsForQAQC(req);
        if (res.status) {
          setLots(res.data);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
          setLots([]);
        }
      }
    } catch (error) {
      AlertMessages.getErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };
  const onReset = () => {
    filterForm.resetFields();
    fetchData();
  }
  const openModal = (record: any) => {
    const type = activeTab === 'lot'
      ? QAQCAnalysisTypeEnum.SILK_FIBER_ANALYSIS
      : QAQCAnalysisTypeEnum.SILK_FIBER_LAB_ANALYSIS;
    setAnalysisType(type);
    setSelectedRecord(record);
    setIsModalVisible(true);
    form.resetFields();
    form.setFieldsValue({ analysisTypeDropdown: type });
  };

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      ) : null
  });

  const closeModal = () => {
    setIsModalVisible(false);
    setAnalysisType(null);
    setSelectedRecord(null);
  };

  const onFinish = async (values: any) => {
    try {
      let res;
      if (analysisType === QAQCAnalysisTypeEnum.SILK_FIBER_ANALYSIS) {
        const payload = new CreateQaqcFibreAnalysisReq();
        payload.workOrderNo = selectedRecord.workOrderNo;
        payload.lotNumber = selectedRecord.lotNumber;
        payload.operation = selectedRecord.operation || '';
        payload.prevOperation = selectedRecord.prevOperation || '';
        payload.product = selectedRecord.outProduct || '';
        payload.quality = selectedRecord.quality || null;
        payload.meanLength = Number(values.meanLength) || 0;
        payload.shortestFiber = Number(values.shortestFiber) || 0;
        payload.longestFiber = Number(values.longestFiber) || 0;
        payload.shortFiberPercent = Number(values.shortFiberPercent) || 0;
        payload.slub = Number(values.slub) || 0;
        payload.testDate = values.testDate
        payload.remarks = values.remarks;
        payload.productionInventoryId = selectedRecord.productionInventoryId;


        payload.quantity =
          selectedRecord.physicalQuantity ??
          selectedRecord.totalQty ??
          selectedRecord.quantity ??
          0;
        res = await qaqcService.createFibreAnalysis(payload);
      } else {
        const payload = new CreateQaqcFibreLabAnalysisReq();
        payload.workOrderNo = selectedRecord.workOrderNo;
        payload.lotNumber = selectedRecord.lotNumber;
        payload.operation = selectedRecord.operation || '';
        payload.prevOperation = selectedRecord.prevOperation || '';
        payload.product = selectedRecord.outProduct || null;
        payload.quality = selectedRecord.quality || null;
        payload.oilTest = Number(values.oilTest) || 0;
        payload.oilTestRemarks = values.oilTestRemarks;
        payload.sericinTest = Number(values.sericinTest) || 0;
        payload.sericinTestRemarks = values.sericinTestRemarks;
        payload.acidityTest = Number(values.acidityTest) || 0;
        payload.acidityTestRemarks = values.acidityTestRemarks;
        payload.ppContent = Number(values.ppContent) || 0;
        payload.ppContentRemarks = values.ppContentRemarks;
        payload.moistureContent = Number(values.moistureContent) || 0;
        payload.moistureContentRemarks = values.moistureContentRemarks;
        payload.testDate = values.testDate
        payload.remarks = values.remarks;
        payload.productionInventoryId = selectedRecord.productionInventoryId;
        payload.quantity =
          selectedRecord.physicalQuantity ??
          selectedRecord.totalQty ??
          selectedRecord.quantity ??
          0; console.log('Lab Analysis Payload:', payload);
        console.log('Selected Record:', selectedRecord);
        res = await qaqcService.createFibreLabAnalysis(payload);
      }

      if (res.status) {
        const successMessage = analysisType === QAQCAnalysisTypeEnum.SILK_FIBER_ANALYSIS
          ? 'Fibre analysis created successfully'
          : 'Fibre lab analysis created successfully';
        AlertMessages.getSuccessMessage(successMessage);
        closeModal();
        fetchData(); // Refresh data
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    } catch (error) {
      AlertMessages.getErrorMessage(error.message);
    }
  };

  const getAllProducts = () => {
    productService.getAllActiveProducts().then(res => {
      if (res.status) {
        console.log(res.data)
        setProductsData(res.data);
      } else {
        if (res.intlCode) {
          setProductsData([]);
          AlertMessages.getErrorMessage('No Data Found');
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setProductsData([]);
    })
  }

  const getAllSkuCodes = () => {
    skucodeservice.getActiveSkuCodes().then(res => {
      if (res.status) {
        setSkuCodesData(res.data);
      } else {
        if (res.intlCode) {
          setSkuCodesData([]);
          AlertMessages.getErrorMessage('No Data Found');
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setSkuCodesData([]);
    })
  }

  const getProductOptionLabel = (product: any) =>
    product.productName || product.name || product.shortCode || product.product || '';

  const getProductOptionValue = (product: any) =>
    product.productId ?? product.product_id ?? product.id;

  const getSkuCodeOptionLabel = (sku: any) =>
    sku.shortCode || sku.short_code || sku.skuCode || sku.sku_code || '';

  const getSkuCodeOptionValue = (sku: any) =>
    sku.skuCodeId ?? sku.sku_code_id ?? sku.id;

  const handleTabChange = (key: string) => {
    filterForm.resetFields(['variant', 'WorkOrder', 'lotNo']);
    setPage(1);
    setActiveTab(key);
  };

  const getWorkOrdersDropdownForQAQC = () => {
    qaqcService.getWorkOrdersDropdownForQAQC().then(res => {
      if (res.status) {
        console.log(res.data)
        setWorkOrdersDropdownData(res.data);
      } else {
        if (res.intlCode) {
          setWorkOrdersDropdownData([]);
          AlertMessages.getErrorMessage('No Data Found');
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setWorkOrdersDropdownData([]);
    })
  }

  const getLotsDropdownForQAQC = () => {
    qaqcService.getLotsDropdownForQAQC().then(res => {
      if (res.status) {
        console.log(res.data)
        setLotNumDropdownData(res.data);
      } else {
        if (res.intlCode) {
          setLotNumDropdownData([]);
          AlertMessages.getErrorMessage('No Data Found');
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setLotNumDropdownData([]);
    })
  }

  const workOrderColumns: ColumnsType<any> = [
   {
          title: "S No",
          key: "id",
          responsive: ["md"],
          align: "left",
          render: (text, object, index) => (page - 1) * 10 + (index + 1),
        },
    {
      title: 'Work Order No',
      dataIndex: 'workOrderNo',
      render: (text) => text || '-',
      sorter: (a, b) => (a.workOrderNo || '').localeCompare(b.workOrderNo || ''),
      sortDirections: ['ascend', 'descend'],
      ...getColumnSearchProps('workOrderNo'),
    },

    {
      title: 'Work Order Date',
      dataIndex: 'workOrderDate',
      sorter: (a, b) =>
        moment(a.workOrderDate).unix() - moment(b.workOrderDate).unix(),
      sortDirections: ['ascend', 'descend'],
      ...getColumnSearchProps('workOrderDate'),
      render: (_, record) =>
        record.workOrderDate
          ? moment(record.workOrderDate).format('DD-MM-YYYY')
          : '-',
    },

    {
      title: 'Variant',
      dataIndex: 'product',
      render: (text) => text || '-',
      sorter: (a, b) => (a.product || '').localeCompare(b.product || ''),
      ...getColumnSearchProps('product'),
    },

    {
      title: 'Quality',
      dataIndex: 'quality',
      render: (text) => text ? text : '-',
      sorter: (a, b) => (a.quality || '').localeCompare(b.quality || ''),
      ...getColumnSearchProps('quality'),
    },

    {
      title: 'Quantity',
      dataIndex: 'totalQty',
      
      sorter: (a, b) => Number(a.totalQty || 0) - Number(b.totalQty || 0),
      ...getColumnSearchProps('totalQty'),
      render: (text) => text ? Number(Number(text).toFixed(2)) : '-',
    },

    

    {
      title: 'Action',
      render: (_, record) => (
        <Space>
          {record?.isQAQCTwoDone === 0 && (
            <ExperimentOutlined
              style={{ color: '#52c41a', cursor: 'pointer' }}
              onClick={() => openModal(record)}
            />
          )}
        </Space>
      ),
    },
  ];

  const lotColumns: ColumnsType<any> = [
    {
          title: "S No",
          key: "id",
          responsive: ["md"],
          align: "left",
          render: (text, object, index) => (page - 1) * 10 + (index + 1),
        },
    {
      title: 'Lot Number',
      dataIndex: 'lotNumber',
      render: (text) => text || '-',
      sorter: (a, b) => (a.lotNumber || '').localeCompare(b.lotNumber || ''),
      ...getColumnSearchProps('lotNumber'),
    },

    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (text) => text || '-',
      sorter: (a, b) => (a.operation || '').localeCompare(b.operation || ''),
      ...getColumnSearchProps('operation'),
    },

    {
      title: 'Prev Operation',
      dataIndex: 'prevOperation',
      render: (text) => text || '-',
      sorter: (a, b) => (a.prevOperation || '').localeCompare(b.prevOperation || ''),
      ...getColumnSearchProps('prevOperation'),
    },

    {
      title: 'Variant',
      dataIndex: 'product',
      render: (text) => text || '-',
      sorter: (a, b) => (a.product || '').localeCompare(b.product || ''),
      ...getColumnSearchProps('product'),
    },

    {
      title: 'Quality',
      dataIndex: 'quality',
      render: (text) => text || '-',
      sorter: (a, b) => (a.quality || '').localeCompare(b.quality || ''),
      ...getColumnSearchProps('quality'),
    },

    {
      title: 'Quantity',
      dataIndex: 'physicalQuantity',
      render: (text) => (text ? Number(Number(text).toFixed(2)) : '-'),
      sorter: (a, b) => Number(a.physicalQuantity || 0) - Number(b.physicalQuantity || 0),
      ...getColumnSearchProps('physicalQuantity'),
    },

    {
      title: 'Action',
      render: (_, record) => (
        <Space>
          {record?.isQAQCOneDone === 0 && (
            <ExperimentOutlined
              style={{ color: '#52c41a', cursor: 'pointer' }}
              onClick={() => openModal(record)}
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <Card
      title={<span style={{ color: 'white' }}>QAQC Analysis</span>}
      style={{ margin: 20 }}
      headStyle={{
        backgroundColor: '#69c0ff',
        border: 0,
        textAlign: 'center',
      }}
      extra={
        <Link to="/qaqc-analysis-view">
          <Button type="primary">View</Button>
        </Link>
      }
    >
      <Form form={filterForm} onFinish={fetchData} layout="inline" style={{ marginBottom: 16 }}>
        <Row gutter={16} style={{ width: '100%' }}>

          <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item
              name="variant"
              label="Variant"
            >
              <Select
                placeholder="Select Variant"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  String(option?.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {activeTab === 'work-order'
                  ? productsData.map(product => {
                    const value = getProductOptionValue(product);
                    const label = getProductOptionLabel(product);
                    return (
                      <Option key={value} value={value}>
                        {label}
                      </Option>
                    );
                  })
                  : skuCodesData.map(sku => {
                    const value = getSkuCodeOptionValue(sku);
                    const label = getSkuCodeOptionLabel(sku);
                    return (
                      <Option key={value} value={value}>
                        {label}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
          {activeTab === 'work-order' && (
            <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
              <Form.Item
                name="WorkOrder"
                label="Work Order"
              >
                <Select
                  placeholder="Select Work Order"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {workOrdersDropdownData.map(workOrder => {
                    return <Option value={workOrder.workOrderNo}>{workOrder.workOrderNo}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
          )}
          {activeTab === 'lot' && (
            <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
              <Form.Item
                name="lotNo"
                label="Lot No"
              >
                <Select
                  placeholder="Select Lot No"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {lotNumDropdownData.map(lot => {
                    return <Option value={lot.lotNumber}>{lot.lotNumber}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item
              name="quality"
              label="Quality"
            >
              <Select
                placeholder="Select Quality"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >

                {Object.values(QualityTypeEnum).map((value) => (
                  <Option key={value} value={value}>
                    {value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        
          <Col style={{ textAlign: 'right', paddingTop: '0px' }}>
            <Button type="primary" htmlType="submit" >
              Submit
            </Button>
            <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
              Reset
            </Button>
          </Col>
        </Row>
      </Form>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
      >
        <Tabs.TabPane tab="Work Order" key="work-order">
          <Table
            columns={workOrderColumns}
            dataSource={workOrders}
            loading={loading}
            rowKey="id"
            
            bordered
            pagination={{
                    current: page,
                    onChange: (current) => setPage(current),
                  }}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Lot" key="lot">
          <Table
            columns={lotColumns}
            dataSource={lots}
            loading={loading}
            rowKey="productionInventoryId"
            pagination={{
                    current: page,
                    onChange: (current) => setPage(current),
                  }}
            bordered
          />
        </Tabs.TabPane>
      </Tabs>

      <Modal
        title={
          <div
            style={{
              background: '#69c0ff',
              padding: '10px 16px',
              margin: '-24px -24px 0 -24px',
              borderRadius: '8px 8px 0 0',
              fontWeight: 600,
              color: '#fff',
            }}
          >
            QAQC Analysis
          </div>
        }
        visible={isModalVisible}
        onCancel={closeModal}
        bodyStyle={{ padding: '12px 16px' }}
        footer={null}
        width={1200}
      >
        {selectedRecord && (
          <div style={{ marginBottom: 30 }}>
            {activeTab === 'work-order' ? (
              <>
                <Row gutter={8}>
                  <Col span={8}><b>Work Order No:</b> {selectedRecord.workOrderNo}</Col>
                  <Col span={8}><b>Work Order Date:</b> {selectedRecord.workOrderDate ? moment(selectedRecord?.workOrderDate).format('DD-MM-YYYY') : 'N/A'}</Col>

                  <Col span={8}><b>Variant:</b> {selectedRecord.product || 'N/A'}</Col>
                </Row>
                <Row gutter={8} style={{ marginTop: 16 }}>
                  <Col span={8}><b>Quality:</b> {selectedRecord.quality || 'N/A'}</Col>
                  <Col span={8}><b>Quantity:</b> {selectedRecord.totalQty ? Number(selectedRecord.totalQty).toFixed(2) : 'N/A'}</Col>

                  <Col span={8}><b>Remarks:</b> {selectedRecord.remarks || 'N/A'}</Col>
                </Row>
              </>
            ) : (
              <>
                <Row gutter={8}>
                  <Col span={8}><b>Lot Number:</b> {selectedRecord.lotNumber}</Col>
                  <Col span={8}><b>Operation:</b> {selectedRecord.operation || 'N/A'}</Col>
                  <Col span={8}><b>Prev Operation:</b> {selectedRecord.prevOperation || 'N/A'}</Col>
                </Row>
                <Row gutter={8} style={{ marginTop: 18 }}>
                  <Col span={8}><b>Variant:</b> {selectedRecord.product || 'N/A'}</Col>
                  <Col span={8}><b>Quality:</b> {selectedRecord.quality || 'N/A'}</Col>
                  <Col span={8}><b>Quantity:</b> {selectedRecord.physicalQuantity ? Number(selectedRecord.physicalQuantity).toFixed(2) : 'N/A'}</Col>
                </Row>
              </>
            )}
          </div>
        )}

        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label="Analysis Type" name="analysisTypeDropdown">
                <Select disabled>
                  <Select.Option value={QAQCAnalysisTypeEnum.SILK_FIBER_ANALYSIS}>Silk Fiber Analysis</Select.Option>
                  <Select.Option value={QAQCAnalysisTypeEnum.SILK_FIBER_LAB_ANALYSIS}>Silk Fiber Lab Analysis</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
            <Form.Item 
              name="testDate" 
              label="Test Date" 
              rules={[{ required: true, message: 'Please select test date' }]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            {analysisType === QAQCAnalysisTypeEnum.SILK_FIBER_ANALYSIS && (
              <>
                <Col span={6}>
                  <Form.Item
                    label="Mean Length"
                    name="meanLength"
                    rules={[
                      { required: true, message: 'Required' },
                      {
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                        message: 'Only numbers allowed (e.g. 2 or 2.66)',
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}

                      stringMode
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    label="Shortest Fiber"
                    name="shortestFiber"
                    rules={[
                      { required: true, message: 'Required' },
                      {
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                        message: 'Only numbers allowed (e.g. 2 or 2.66)',
                      },
                    ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    label="Longest Fiber"
                    name="longestFiber"
                    rules={[
                      { required: true, message: 'Required' },
                      {
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                        message: 'Only numbers allowed (e.g. 2 or 2.66)',
                      },
                    ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    label="% of Short Fiber"
                    name="shortFiberPercent"
                    rules={[
                      { required: true, message: 'Required' },
                      {
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                        message: 'Only numbers allowed (e.g. 2 or 2.66)',
                      },
                    ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    label="Slub"
                    name="slub"
                    rules={[
                      { required: true, message: 'Required' },
                      {
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                        message: 'Only numbers allowed (e.g. 2 or 2.66)',
                      },
                    ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Remarks" name="remarks">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
              </>
            )}

            {analysisType === QAQCAnalysisTypeEnum.SILK_FIBER_LAB_ANALYSIS && (
              <>
                <Col span={6}>
                  <Form.Item label="Oil Test" name="oilTest" rules={[
                    { required: true, message: 'Required' },
                    {
                      pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                      message: 'Only numbers allowed (e.g. 2 or 2.66)',
                    },
                  ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Oil Test Remarks" name="oilTestRemarks">
                    <Input.TextArea rows={1} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Sericin Test" name="sericinTest" rules={[
                    { required: true, message: 'Required' },
                    {
                      pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                      message: 'Only numbers allowed (e.g. 2 or 2.66)',
                    },
                  ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Sericin Test Remarks" name="sericinTestRemarks">
                    <Input.TextArea rows={1} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Acidity Test" name="acidityTest" rules={[
                    { required: true, message: 'Required' },
                    {
                      pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                      message: 'Only numbers allowed (e.g. 2 or 2.66)',
                    },
                  ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Acidity Test Remarks" name="acidityTestRemarks">
                    <Input.TextArea rows={1} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="PP Content" name="ppContent" rules={[
                    { required: true, message: 'Required' },
                    {
                      pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                      message: 'Only numbers allowed (e.g. 2 or 2.66)',
                    },
                  ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="PP Content Remarks" name="ppContentRemarks">
                    <Input.TextArea rows={1} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Moisture Content" name="moistureContent" rules={[
                    { required: true, message: 'Required' },
                    {
                      pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,
                      message: 'Only numbers allowed (e.g. 2 or 2.66)',
                    },
                  ]}
                  >
                    <InputNumber style={{ width: '100%' }} stringMode />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Moisture Content Remarks" name="moistureContentRemarks">
                    <Input.TextArea rows={1} />
                  </Form.Item>
                </Col>

              </>
            )}

            <Col>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Card>
  );
};

export default QaqcAnalysisView;
